import "./ToolMessage.css";

type ToolMessageProps = {
  toolType: string;
};

export const ToolMessage = ({ toolType }: ToolMessageProps) => {
  const getToolLabel = (type: string) => {
    switch (type) {
      case "retrievalTool":
        return "checking your documents...";
      case "dateTool":
        return "checking the date...";
      default:
        return `Tool - ${type}`;
    }
  };

  return (
    <div className="agent-chat-history-item">
      <div className="tool-message">
        <div className="tool-logo">
          <img src="/icons/tools.svg" alt="Tool" />
        </div>
        <span>{getToolLabel(toolType)}</span>
      </div>
    </div>
  );
};
